// Polyfills for Node.js timer functions in browser environment
if (typeof globalThis.setImmediate === 'undefined') {
  // @ts-ignore - __promisify__ property is Node.js-specific, not needed in browser
  globalThis.setImmediate = (callback: (...args: any[]) => void, ...args: any[]) => {
    const id = setTimeout(() => callback(...args), 0);
    // Add _onTimeout property to make it compatible with Node.js Timeout object
    (id as any)._onTimeout = callback;
    return id;
  };
}

if (typeof globalThis.clearImmediate === 'undefined') {
  // @ts-ignore - Node.js type compatibility not required in browser environment
  globalThis.clearImmediate = (id: any) => {
    clearTimeout(id);
  };
}

import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, HashRouter } from 'react-router-dom';
import App from './App.tsx';
import './index.css';

const queryClient = new QueryClient();

// Bepaal welke router te gebruiken
const isBoltEnvironment = window.location.hostname.includes('bolt.new') || window.location.hostname.includes('webcontainer');
const Router = isBoltEnvironment ? HashRouter : BrowserRouter;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <Router>
        <App />
      </Router>
    </QueryClientProvider>
  </React.StrictMode>,
);